import { useState } from 'react';
import { getExpressPaymentMethodsAvailability } from '../../components/ExpressCheckout/getExpressPaymentMethodsAvailability';
import { ExpressPaymentMethodStatus } from '../../models/expressCheckout';

export const useNotifyOnTicketLayoutStabilized = ({
    allowApplePay,
    allowGooglePay,
    allowPayPal,
    applePayExpressPaymentMethodStatus,
    areAllSelectedTicketsFree,
    areTicketsSelected,
    googlePayExpressPaymentMethodStatus,
    notifyOnTicketLayoutStabilized,
    paypalExpressPaymentMethodStatus,
    hasAsyncApplePayErrors,
}: {
    allowApplePay: boolean;
    allowGooglePay: boolean;
    allowPayPal: boolean;
    applePayExpressPaymentMethodStatus: ExpressPaymentMethodStatus;
    areAllSelectedTicketsFree: boolean;
    areTicketsSelected: boolean;
    googlePayExpressPaymentMethodStatus: ExpressPaymentMethodStatus;
    notifyOnTicketLayoutStabilized: () => void;
    paypalExpressPaymentMethodStatus: ExpressPaymentMethodStatus;

    hasAsyncApplePayErrors: boolean;
}) => {
    const [hasNotified, setHasNotified] = useState(false);

    if (hasNotified) {
        return;
    }

    const {
        shouldShowApplePayButton,
        shouldShowGooglePayButton,
        shouldShowPaypalButton,
    } = getExpressPaymentMethodsAvailability({
        areAllSelectedTicketsFree,
        areTicketsSelected,
        hasAsyncApplePayErrors,
        isExpressApplePayEnabled: allowApplePay,
        isExpressGooglePayEnabled: allowGooglePay,
        isExpressPayPalEnabled: allowPayPal,
    });

    const isLoadingExpressCheckout = [
        {
            shouldShow: shouldShowApplePayButton,
            status: applePayExpressPaymentMethodStatus,
        },
        {
            shouldShow: shouldShowGooglePayButton,
            status: googlePayExpressPaymentMethodStatus,
        },
        {
            shouldShow: shouldShowPaypalButton,
            status: paypalExpressPaymentMethodStatus,
        },
    ].some(({ shouldShow, status }) => {
        if (!shouldShow) {
            return (
                status ===
                ExpressPaymentMethodStatus.availabilityNotEvaluatedYet
            );
        }

        return status !== ExpressPaymentMethodStatus.fullyLoaded;
    });

    if (isLoadingExpressCheckout) {
        return;
    }

    notifyOnTicketLayoutStabilized();
    setHasNotified(true);
};
